import React from 'react'

export default function ProtocoloSeguridad() {
  return (
    <div>
      ProtocoloSeguridad
    </div>
  )
}
